/**
 * 兜底 mock 数据：仅在未登录 / 后端不可用时提供一个空白用户对象
 * 游戏/Banner/排行榜相关数据全部改为从后端 portal.home 派生
 */

export function getMockUserData() {
  return {
    userId: null,
    username: '',
    nickname: '游戏玩家',
    avatar: '',
    mobile: '',
    level: 1,
    exp: 0,
    totalExp: 100,
    levelName: '青铜玩家',
    levelIcon: '🥉',
    levelColor: '#B0B0B0',
    gameRecordCount: 0,
    totalPlayTime: '0小时',
    joinDate: ''
  }
}
